import React from 'react';
import Scorebook from '../containers/Scorebook.tsx';

export default (props) => (
  <Scorebook {...props} />
);
